export enum SampleAnalysisItemsType {
    'All',
    'OnlyQuotedItems',
    'OnlyMonograph'
}
